module.exports = "/_next/static/images/icon_equal-c28a350f4b5401748a3301184246bb8a.svg";